import type { WriteOffLocation } from '@eombor/contracts';

/**
 * Kutish chegarasi: undan uzoq kutish odamni tugma oldida ushlab turardi
 * va u «osilib qoldi» deb o'ylardi.
 */
const TIMEOUT_MS = 8000;

/**
 * RASXOD JOYINI oladi — OLINMASA `null`.
 *
 * Hech qachon ISTISNO tashlamaydi va bu ataylab: lokatsiya qo'shimcha
 * dalil, aktning SHARTI emas. Ruxsat berilmagan, signal yo'q yoki brauzer
 * eski bo'lsa, akt lokatsiyasiz ketadi va buxgalter ro'yxatda
 * «lokatsiyasiz» belgisini ko'radi — u o'zi so'rashi mumkin.
 *
 * Qattiq to'silsa, telefonida geolokatsiya o'chiq xodim umuman rasxod
 * qila olmay qolardi.
 */
export const captureLocation = (): Promise<WriteOffLocation | null> =>
  new Promise((resolve) => {
    const geo: Geolocation | undefined = navigator.geolocation;
    if (geo === undefined) {
      resolve(null);
      return;
    }

    geo.getCurrentPosition(
      (position) =>
        resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy,
        }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: TIMEOUT_MS, maximumAge: 0 },
    );
  });
